export default "__VITE_ASSET__35acac5c__"